import React, { useEffect, useRef, useState } from "react";
import FilledInput from "../forms/inputs/filledInput";
import { Checkbox, FormControlLabel, IconButton, InputAdornment } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { isUrlValid } from "utils/isUrlValid";

import "./urlField.sass";

interface IUrlFieldProps {
    url: string;
    openInNewWindow: boolean;
    placeholderText?: string;
    setUrl: (url: string) => void;
    setOpenInNewWindow: (openInNewWindow: boolean) => void;
}

export const UrlField: React.FC<IUrlFieldProps> = ({
    url,
    openInNewWindow,
    placeholderText,
    setUrl,
    setOpenInNewWindow
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [hasUrl, setHasUrl] = useState<boolean>(!!url);

    useEffect(() => {
        setHasUrl(!!url);
    }, [url]);

    return <>
        <FilledInput
            refreshable
            value={url}
            label={""}
            variant="outlined"
            inputRef={inputRef}
            inputProps={{
                placeholder: placeholderText,
                style: {
                    fontSize: '1rem'
                },
                onBlur: (e) => setUrl(e.target.value),
            }}
            setMagicButtonDisabled={(disabled) => setHasUrl(!disabled)}
            InputProps={{
                endAdornment: <InputAdornment position="end">
                    <IconButton
                        size="small"
                        aria-label="Open link in new tab"
                        disabled={!hasUrl}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => {
                            const typedUrl = inputRef.current?.value || url;
                            const absoluteUrl = isUrlValid(typedUrl) ? typedUrl : `https://${typedUrl}`;

                            window.open(absoluteUrl, "_blank", "noopener,noreferrer");
                        }}
                        sx={{ "&.Mui-disabled": { backgroundColor: "transparent" } }}
                    >
                        <OpenInNewIcon/>
                    </IconButton>
                </InputAdornment>
            }}
            size="small"
            inputContainerStyle={{ minHeight: 40, marginBottom: 0 }}
            style={{ minHeight: 40 }}
            inputLabelContainerStyle={{ display: 'none' }}
        />
        <FormControlLabel 
            control={
                <Checkbox 
                    defaultChecked={openInNewWindow} 
                    onChange={(_, checked) => setOpenInNewWindow(checked)}
                />
            } 
            label="Open in new tab"
            className="url-field-open-in-label"
        />
    </>;
};
